// extracted by mini-css-extract-plugin
export var activeFilterButton = "_qi-c";
export var backButton = "_qi-4";
export var backIcon = "_qi-5";
export var chevronShortcut = "_qi-6";
export var container = "_qi-1";
export var editor = "_qi-8";
export var editorWrapper = "_qi-7";
export var prefix = "_qi-2";
export var searchIcon = "_qi-3";
export var suffix = "_qi-9";
export var suffixContent = "_qi-a";
export var suffixText = "_qi-b";
export var wrapper = "_qi-0";